// The Budget table's columns for each tab (Budget, Client View): heading, width, alignment and
// whether the cell can be edited. Used by the table (pages/budget.js) and its editor (ui/table-editor.js).
import { CUR, ccySym } from '../core/budget.js';

export const COLS = {
  budget: [{
    k: 'ln',
    h: '#',
    w: 36,
    al: 'center'
  }, {
    k: 'desc',
    h: 'Description',
    w: 220,
    edit: true,
    type: 'text'
  }, {
    k: 'st',
    h: 'Status',
    w: 110,
    edit: true,
    type: 'select',
    opts: ['Contracted', 'Confirmed', 'Quoted', 'TBC', 'Invoiced', 'Paid', 'Cancelled']
  }, {
    k: 'sup',
    h: 'Supplier',
    w: 140,
    edit: true,
    type: 'text'
  }, {
    k: 'ccy',
    h: 'CCY',
    w: 58,
    al: 'center',
    edit: true,
    type: 'select',
    opts: '_fx_'
  }, {
    k: 'qty',
    h: 'Qty',
    w: 50,
    al: 'right',
    edit: true
  }, {
    k: 'unit',
    h: 'Unit',
    w: 60,
    edit: true,
    type: 'text'
  }, {
    k: 'up',
    h: 'Unit Price',
    w: 88,
    al: 'right',
    edit: true
  }, {
    k: 'vat',
    h: 'VAT %',
    w: 58,
    al: 'right',
    edit: true,
    type: 'pct'
  }, {
    // in the line's own currency; subtotals and totals in the project's cost currency
    k: 'inGBP',
    h: 'In-Cost',
    w: 100,
    al: 'right'
  }, {
    k: 'spent',
    h: 'Spent',
    w: 112,
    al: 'left'
  }, {
    // how much of the line its sub-budgets plan to use
    k: 'plan',
    h: 'Planned',
    w: 175,
    al: 'left'
  }, {
    k: 'mu',
    h: 'Markup',
    w: 65,
    al: 'right',
    edit: true,
    type: 'pct'
  }, {
    // typing an out-cost sets the markup that gives it (table-editor.js)
    k: 'outUSD',
    get h() { return 'Out-Cost ' + ccySym(CUR.bill).trim(); },
    w: 100,
    al: 'right',
    edit: true
  }, {
    k: 'marg',
    get h() { return 'Margin ' + ccySym(CUR.bill).trim(); },
    w: 90,
    al: 'right'
  }],
  client: [{
    k: 'ln',
    h: '#',
    w: 36,
    al: 'center'
  }, {
    k: 'desc',
    h: 'Description',
    w: 280
  }, {
    k: 'sup',
    h: 'Supplier',
    w: 160
  }, {
    k: 'qty',
    h: 'Qty',
    w: 55,
    al: 'right'
  }, {
    k: 'unit',
    h: 'Unit',
    w: 56
  }, {
    k: 'upUSD',
    get h() { return 'Unit Price ' + ccySym(CUR.bill).trim(); },
    w: 110,
    al: 'right'
  }, {
    k: 'outUSD',
    get h() { return 'Total ' + ccySym(CUR.bill).trim(); },
    w: 120,
    al: 'right'
  }]
};
